import * as Yup from 'yup';
import type { TFunction } from 'i18next';
import { resolveCopy } from 'src/utils/resolveApiError';
import { MAX_LEAD_TEXT_FIELD_LENGTH } from './ChatInfoAttributes.constants';

// Mirrors leads-service UpdateLeadRequest (full_name/email/company are all max:255),
// so an over-long value is caught in the form instead of coming back as a 422 the
// user cannot interpret. The component already renders formik.errors.full_name.
//
// A factory rather than a module constant because the length message is
// user-visible and must be localized (CLAUDE.md: all user-visible strings go
// through react-i18next). `t` is bound to the `errors/errors` namespace, which
// owns apiErrors.tooLong in es/en/br.
export function buildChatInfoAttributesSchema(t: TFunction) {
  // resolveCopy, not raw t(): a missing key here would put "apiErrors.tooLong"
  // itself under the input as the validation message — the RET-1977 failure
  // mode this module's resolver exists to prevent, reached from a caller that
  // wasn't going through the resolver.
  const tooLong = resolveCopy(t, 'apiErrors.tooLong', {
    field: resolveCopy(t, 'apiErrors.fields.full_name'),
    max: MAX_LEAD_TEXT_FIELD_LENGTH,
  });

  return Yup.object({
    full_name: Yup.string().required().max(MAX_LEAD_TEXT_FIELD_LENGTH, tooLong),
    email: Yup.string()
      .email('Invalid email address')
      .max(MAX_LEAD_TEXT_FIELD_LENGTH, tooLong),
    value: Yup.number(),
    company: Yup.string().max(MAX_LEAD_TEXT_FIELD_LENGTH, tooLong),
    revenue: Yup.number(),
  });
}
